// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vxe-grid--toolbar-wrapper {\r\n    position: absolute;\r\n    top: -71px;\r\n    right: 6px;\n}\r\n", ""]);
// Exports
module.exports = exports;
